import LegalCheckboxLabel from '../LegalCheckboxLabel';
import MarketingCheckboxLabel from '../MarketingCheckboxLabel';
import { required, email, minLength6 } from '../../../../utilities/validators';
import Checkbox from '../../../../fields/reduxForm/GeneralCheckbox';
import TextField from '../../../../fields/reduxForm/GeneralTextField';
import SelectFormField from '../../../../fields/reduxForm/SelectFormField';

const formFields = [
  // {
  //   name: 'name',
  //   component: TextField,
  //   props: {
  //     id: 'full-name-text-field',
  //     label: 'Full Name',
  //     fullWidth: true,
  //   },
  //   validate: [required],
  // },
  {
    name: 'custom:firstName',
    component: TextField,
    props: {
      id: 'first-name-text-field',
      label: 'First Name',
      fullWidth: true,
      required: true,
    },
    validate: [required],
  },
  {
    name: 'custom:surname',
    component: TextField,
    props: {
      id: 'surname-name-text-field',
      label: 'Surname',
      fullWidth: true,
      required: true,
    },
    validate: [required],
  },
  {
    name: 'custom:roleType',
    component: SelectFormField,
    props: {
      id: 'role-type-select-field',
      label: 'Role Type',
      fullWidth: true,
      required: true,
    },
    validate: [required],
  },
  {
    name: 'custom:personalEmail',
    component: TextField,
    props: {
      id: 'personal-email-text-field',
      label: 'Email Address',
      fullWidth: true,
      required: true,
    },
    validate: [required, email],
  },
  {
    name: 'password',
    component: TextField,
    props: {
      id: 'password-text-field',
      label: 'Password',
      fullWidth: true,
      type: 'password',
      required: true,
    },
    validate: [required, minLength6],
  },
  {
    name: 'legal',
    component: Checkbox,
    props: {
      id: 'legal-checkbox',
      label: LegalCheckboxLabel,
    },
  },
  {
    name: 'custom:marketingOptIn',
    component: Checkbox,
    props: {
      id: 'marketingOptIn-checkbox',
      label: MarketingCheckboxLabel,
    },
  },
];

export default formFields;
